// Chakra 
import { 
  Button,
  Flex, 
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text, 
} from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { SiCrystal } from 'react-icons/si';
import { textLang } from 'services/Lang';

const LikedModal = ({handle, onOpen, isOpen, onClose, userData, isLoadingBtn}) => {

  const history = useHistory();
  const handleGoToWallet = async () => {
    onClose();  
    history.push('/profile/balance'); 
  };

  return (
    	<> 
        <Modal isOpen={isOpen} onClose={isLoadingBtn ? () => {} : () => {
          onClose();
        }}>
          <ModalOverlay />
          <ModalContent className="modal__simple" 
              maxW={{ base: '330px' }} 
              style={{ border:'1px solid #2ABDFD', overflow: 'hidden' }}>
              <Box position="relative" p="24px" bg='white !important' textAlign="center">
                  { (userData?.balance + userData?.balanceDaily) >= 1000 ?
                    <><Text variant="title-lg">
                      {textLang('open_likes_header')}
                    </Text>

                    <Text variant="text-md" mt="8px">
                      {textLang('open_likes_text')}
                    </Text>
                    {isLoadingBtn}
                    <Flex mt="18px" gap="12px">
                      <Button disabled={ (userData?.balance + userData?.balanceDaily) < 1000 ? true : false } variant="button-md" onClick={() => { handle(); }} 
                        isLoading={isLoadingBtn}
                        rightIcon={<SiCrystal fontSize="24px" />}>{textLang('open_for')} 1000</Button>
                    </Flex>
                    </>
                    :
                    <>
                    <Text variant="title-lg">
                      Warning!
                    </Text>

                    <Text variant="text-md" mt="8px">
                     You don`t have enough soul crystals. Please top up your balance.
                    </Text>

                    <Flex mt="18px" gap="12px">
                      <Button  variant="button-md" onClick={handleGoToWallet} 
                        >Go to wallet</Button>
                    </Flex>
                    </>
                  }
              </Box>
          </ModalContent>
        </Modal> 
      </>
  );
};

export default LikedModal;